import React, { useCallback, useEffect, useState } from "react";
import { getLanguageSection } from "../../../shared/services/languageService";

// Modal de bienvenida al programa de agentes. Un solo componente que montan
// tanto page.login.js como page.agentregister.js: se abre al entrar a
// cualquiera de esas dos rutas y se cierra manualmente (mismo patrón
// autocontenido que MultimediaLibraryModal).

function IconEarnings() {
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
      <circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.6" />
      <path d="M14.5 9.3c-.5-.8-1.4-1.2-2.5-1.2-1.4 0-2.4.7-2.4 1.8 0 2.4 5 1.2 5 3.8 0 1.2-1.1 1.9-2.6 1.9-1.2 0-2.1-.4-2.6-1.2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M12 6.4v11.2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

function IconDelight() {
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
      <path d="m12 20-1.2-1.1C6.5 15.1 4 12.8 4 9.9 4 7.6 5.8 5.8 8.1 5.8c1.3 0 2.6.6 3.4 1.6.8-1 2.1-1.6 3.4-1.6 2.3 0 4.1 1.8 4.1 4.1 0 2.9-2.5 5.2-6.8 9L12 20Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
  );
}

function IconConfidence() {
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
      <path d="M12 3.5 5 6.2v5c0 4 2.9 7.6 7 9.3 4.1-1.7 7-5.3 7-9.3v-5L12 3.5Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="m9 12 2.2 2.2L15.4 10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function IconOnePlace() {
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
      <rect x="3.8" y="3.8" width="7" height="7" rx="1.6" stroke="currentColor" strokeWidth="1.6" />
      <rect x="13.2" y="3.8" width="7" height="7" rx="1.6" stroke="currentColor" strokeWidth="1.6" />
      <rect x="3.8" y="13.2" width="7" height="7" rx="1.6" stroke="currentColor" strokeWidth="1.6" />
      <rect x="13.2" y="13.2" width="7" height="7" rx="1.6" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
}

function IconSupport() {
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
      <path d="M4.5 14v-2a7.5 7.5 0 0 1 15 0v2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <rect x="2.8" y="13.4" width="3.6" height="5.4" rx="1.8" stroke="currentColor" strokeWidth="1.6" />
      <rect x="17.6" y="13.4" width="3.6" height="5.4" rx="1.8" stroke="currentColor" strokeWidth="1.6" />
      <path d="M19.4 18.8c0 1.4-1.5 2.4-3.4 2.4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

function IconGrowth() {
  return (
    <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
      <path d="M4 19V5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M4 19h16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="m7.5 14.5 3.5-4 3 2.6 4.5-5.6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.4 7.2h3.6v3.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function WelcomeAgentsModal() {
  const language = getLanguageSection("welcomemodal");
  // Abierto al montar: la página que lo renderiza es la que decide cuándo se ve.
  const [isOpen, setIsOpen] = useState(true);
  const onClose = useCallback(() => setIsOpen(false), []);

  useEffect(() => {
    if (typeof document === "undefined" || !isOpen) return undefined;

    // Bloquea el scroll del fondo y permite cerrar con Escape.
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

//REACT_APP_JUST_MARIVAL_REWARDS=false

  if(process.env.REACT_APP_JUST_MARIVAL_REWARDS === "true") {
    return null;
  }

  const benefits = [
    { icon: <IconEarnings />, title: language.benefit1Title, text: language.benefit1Text },
    { icon: <IconDelight />, title: language.benefit2Title, text: language.benefit2Text },
    { icon: <IconConfidence />, title: language.benefit3Title, text: language.benefit3Text },
    { icon: <IconOnePlace />, title: language.benefit4Title, text: language.benefit4Text },
    { icon: <IconSupport />, title: language.benefit5Title, text: language.benefit5Text },
    { icon: <IconGrowth />, title: language.benefit6Title, text: language.benefit6Text }
  ];

  return (
    // El velo y el blur van inline a propósito: son utilidades de valor
    // arbitrario y public/tailwind.css solo se regenera en prestart/prebuild,
    // así que inline sobreviven aunque el CSS esté desfasado.
    // El overlay es el único que hace scroll (items-start, sin alto máximo en
    // la tarjeta): la rueda mueve el modal completo como si fuera la página,
    // en vez de tener una barra interna dentro del cuerpo del modal.
    <div
      className="fixed inset-0 flex items-start justify-center overflow-y-auto px-4 py-8"
      style={{
        zIndex: 1300,
        background: "rgba(11,16,48,0.7)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)"
      }}
      role="dialog"
      aria-modal="true"
      aria-label={language.heading}
      onClick={onClose}
    >
      {/* stopPropagation: el clic dentro de la tarjeta no debe cerrar el modal. */}
      <div
        className="my-auto flex w-full max-w-3xl flex-col overflow-hidden rounded-2xl bg-white"
        style={{ boxShadow: "0 30px 80px rgba(8,16,48,0.45)" }}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="relative bg-marival-navy px-6 py-7 text-white md:px-9 md:py-8">
          <button
            type="button"
            className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full border border-white/25 bg-white/5 text-white transition hover:bg-white/15"
            aria-label={language.closeLabel}
            onClick={onClose}
          >
            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M6 6l12 12M18 6 6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>

          <p className="m-0 text-[11px] font-black uppercase tracking-[0.22em] text-[#b8935a]">
            {language.badge}
          </p>
          <h2 className="m-0 mt-3 max-w-lg text-2xl font-black leading-tight md:text-3xl">
            {language.heading}
          </h2>
        </div>

        <div className="px-6 py-7 md:px-9 md:py-8">
          <p className="m-0 text-base leading-7 text-slate-600">{language.intro1}</p>
          <p className="m-0 mt-4 text-base leading-7 text-slate-600">{language.intro2}</p>

          <div className="mt-8 flex items-center gap-3">
            <h3 className="m-0 whitespace-nowrap text-lg font-black text-marival-navy md:text-xl">
              {language.whyTitle}
            </h3>
            <span className="h-px flex-1 bg-slate-200" aria-hidden="true" />
          </div>

          <div className="mt-5 grid gap-4 md:grid-cols-2">
            {benefits.map((benefit, i) => (
              <div
                key={i}
                className="flex gap-4 rounded-xl border border-slate-200 bg-slate-50 p-4 transition hover:border-marival-blue hover:bg-white"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[#eaf6fb] text-marival-blue">
                  {benefit.icon}
                </span>
                <div>
                  <h4 className="m-0 text-sm font-black leading-5 text-marival-navy">{benefit.title}</h4>
                  <p className="m-0 mt-1.5 text-sm leading-6 text-slate-600">{benefit.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-slate-200 bg-white px-6 py-4 md:px-9">
          <button
            type="button"
            className="inline-flex h-12 w-full items-center justify-center rounded-md border-0 bg-[#4f9ac4] text-sm font-black text-white shadow-[0_12px_24px_rgba(79,154,196,0.26)] transition hover:bg-[#438eb8]"
            onClick={onClose}
          >
            {language.ctaText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default WelcomeAgentsModal;
